import React from 'react';
import { CheckCircle2, Circle, Clock } from 'lucide-react';
import type { LessonStatus } from '../types/api';

// The backend knows only 'not_started' and 'submitted' (SubmissionStatus); the per-lesson status endpoint adds
// 'started' for a saved draft. Anything else (an older or newer backend) shows as its raw value.
const STATUS_DISPLAY: Record<LessonStatus, { label: string; Icon: typeof Clock; classes: string }> = {
  not_started: {
    label: 'Not Started',
    Icon: Circle,
    classes: 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-700',
  },
  started: {
    label: 'In Progress',
    Icon: Clock,
    classes: 'bg-amber-50 dark:bg-amber-950/50 text-amber-800 dark:text-amber-300 border-amber-200 dark:border-amber-900',
  },
  submitted: {
    label: 'Submitted',
    Icon: CheckCircle2,
    classes: 'bg-emerald-50 dark:bg-emerald-950/50 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-900',
  },
};

const SIZES = {
  sm: 'gap-1 px-2 py-0.5 text-xs [&_svg]:w-3.5 [&_svg]:h-3.5',
  md: 'gap-1.5 px-2.5 py-1 text-xs sm:text-sm [&_svg]:w-4 [&_svg]:h-4',
};

const StatusBadge: React.FC<{ status: string | null | undefined; size?: keyof typeof SIZES }> = ({ status, size = 'md' }) => {
  const display = STATUS_DISPLAY[(status || 'not_started') as LessonStatus] ?? {
    label: String(status),
    Icon: Circle,
    classes: STATUS_DISPLAY.not_started.classes,
  };
  const { Icon } = display;

  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded-full font-medium border ${SIZES[size]} ${display.classes}`}>
      <Icon />
      {display.label}
    </span>
  );
};

export default StatusBadge;
